import React, { useState, useEffect, Fragment, useMemo } from "react";
import {
  Row,
  Card,
  Col,
  Label,
  Input,
  Table,
  UncontrolledTooltip
} from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import BreadcrumbLink from "../../../components/Common/BreadcrumbLink";
import i18n from "../../../i18n";
import { createSelector } from "reselect";
import StyledPagination from "../../../components/Common/StyledPagination.jsx";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Spinners from "../../../components/Common/Spinner";
import { useFormik } from "formik";
import AlertSuccess from "../../../components/Alerts/AlertSuccess.jsx";
import AlertError from "../../../components/Alerts/AlertError";
import Select from "react-select";
import {
  getOrgsAdmin as onGetOrgsAdmin,
  getEmployeesAdmin,
  postEmployeesAdminCreateAddress,
  postServicesAdmin,
  putPlatformRequest,
  getServiceRequestAdmin,
  postServicesAssignAdmin,
  getPlates,
  getPlatesOnboard
} from "../../../helpers/api_rombo_helper";
import Places from "../../Google/Places/index.jsx";
import PlacesServices from "../../Google/PlacesServices";
import MapServices from "../../Google/MapServices";
import { map, chunk, debounce } from "lodash";
import { useNavigate } from "react-router-dom";
import { BookingType, VisibilityTypes, TypeAddress } from "../../../constants/enums";
import { saveToLocalStorage } from "../../../constants/storage";
import { orgId, isPartnerAllowed } from "../../../constants/utils";
import * as Yup from "yup";

const ExpressRequestService = (props) => {
  document.title = `${i18n.t("ServiceRequest")} - ${orgId}`;

  const dispatch = useDispatch();
  const history = useNavigate();
  const [infoUser, setInfoUser] = useState({ is_staff: false, permissions: [] });
  const [showRequestData, setShowRequestData] = useState(true);
  const [showAssignedUnit, setShowAssignedUnit] = useState(false);
  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  const [alertHeader, setAlertHeader] = useState("");
  const [alertBody, setAlertBody] = useState("");
  const [listCompanies, setListCompanies] = useState([]);
  const [listTypeService, setListTypeService] = useState([]);
  const [company, setCompany] = useState({});
  const [typeService, setTypeService] = useState({ label: i18n.t("TextService2"), value: BookingType.CLOSED });
  const [showCompany, setShowCompany] = useState(true);
  const [showGeneral, setShowGeneral] = useState(false);
  const [showDateHour, setShowDateHour] = useState(true);
  const [showTypeService, setShowTypeService] = useState(false);
  const [showAdditionalNote, setShowAdditionalNote] = useState(true);
  const [showAddresses, setShowAddresses] = useState(true);
  const [showUnits, setShowUnits] = useState(false);
  const [showIdTag, setShowIdTag] = useState(false);
  const [showEmployees, setShowEmployees] = useState(false);
  const [showEmployeesAvailable, setShowEmployeesAvailable] = useState(false);
  const [showScales, setShowScales] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [onFocusAddress, setOnFocusAddress] = useState("");
  const [newCreateAddressEmployee, setNewCreateAddressEmployee] = useState({});
  const [formatEmployees, setFormatEmployees] = useState([]);
  const [arrScales, setArrScales] = useState([{ id: 3, latLon: false, typeAddress: TypeAddress.ARRAY_SCALES, dragg: false, editRow: false, onDrag: false, passenger_id: null, name: null, address: { location: { lon: -99.1446503251791, lat: 19.46416132507601 } } }]);
  const [opts, setOpts] = useState({});
  const [aditionalNote, setAditionalNote] = useState("");
  const [idTag, setIdTag] = useState("");
  const [showNextBlock, setShowNextBlock] = useState(false);
  const [disableTextarea, setDisableTextarea] = useState(false);
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [selectedDestiny, setSelectedDestiny] = useState(null);
  const [originAddressService, setOriginAddressService] = useState({});
  const [destinyAddressService, setDestinyAddressService] = useState({});
  const [addressesMarkers, setAddressesMarkers] = useState([]);
  const [units, setUnits] = useState(1);
  const [titleAdressDestiny, setNameTitleDestiny] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Destiny"), address: "" }));
  const [titleAdressOrigin, setNameTitleOrigin] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Origin"), address: "" }));
  const [titleAdressArrScales, setNameTitleArrScales] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Employee"), address: "" }));
  const [titleAdressArrEmployees, setNameTitleEmployees] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Scale"), address: "" }));
  const [employees, setEmployees] = useState([]);
  const [employeesSelectedFind, setEmployeesSelectedFind] = useState([]);
  const [employeesSelected, setEmployeesSelected] = useState([]);
  const [findEmployees, setFindEmployees] = useState([]);
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [editingEmployees, setEditingEmployees] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [validationsAddresses, setValidationsAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [temporarySelections, setTemporarySelections] = useState({});
  const [serviceCode, setServiceCode] = useState(null);
  const [searchPlateQuery, setSearchPlateQuery] = useState("");
  const [plateResults, setPlateResults] = useState([]);
  const [isLoadingPlates, setIsLoadingPlates] = useState(false);
  const [showPlateDropdown, setShowPlateDropdown] = useState(false);
  const [selectedPlate, setSelectedPlate] = useState(null);
  const [continueClicked, setContinueClicked] = useState(false);
  const [editingAddressForEmployee, setEditingAddressForEmployee] = useState({});
  const [newAddress, setNewAddress] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [tempAddress, setTempAddress] = useState({});
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const [errorAlertHeader, setErrorAlertHeader] = useState(i18n.t("ServiceAlertError"));
  const [errors, setErrors] = useState({
    origin: false,
    destiny: false,
    company: false,
    date: false,
    hour: false,
    typeService: false,
  });

  const [dateService, setDateService] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
  });

  const [hourService, setHourService] = useState(() => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 5);
    return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
  });

  const [minTime, setMinTime] = useState(() => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 5);
    return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
  });  

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  const setError = (field, value) => {
    setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: value,
    }));
  };

  const autoformik = useFormik({
    initialValues: {
      search: "",
      email: "",
      identifier: "",
      depot: ""
    },
    validationSchema: Yup.object({
      search: Yup.string(),
      email: Yup.string(),
      identifier: Yup.string(),
      depot: Yup.string()
    })
  });

  useEffect(() => {
    getMinutes(dateService);
  }, []);
  
  useEffect(() => {
    getMinutes(dateService);
  }, [dateService]);  

  useEffect(() => {
    fillTypeService()
    getMinutes()
    infoUser.is_staff ? getCompanies() : fillCompany();
  }, [dispatch, infoUser]);
  
  useEffect(() => {
    onGetEmployeesAdmin()
  }, [dispatch, company]);

  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [data, loading]);

  useEffect(() => {
    fEmployee();
  }, [employeesSelected]);

  useEffect(() => {
    if (editingEmployee?.addresses?.length > 0) {
      setSelectedAddress(editingEmployee.addresses[0].id);
    }
  }, [editingEmployee]);

  useEffect(() => {
    const now = new Date();
    if (dateService) {
      const selectedDate = new Date(dateService);
      const today = new Date();
      
      if (
        selectedDate.getDate() === today.getDate() &&
        selectedDate.getMonth() === today.getMonth() &&
        selectedDate.getFullYear() === today.getFullYear()
      ) {
        now.setMinutes(now.getMinutes() + 5);
        setMinTime(now);
      } else {
        setMinTime("");
      }
    }
  }, [dateService]);

  useEffect(() => {
    fillTypeService();
  }, []);
  
  useEffect(() => {
    fillTypeService();
    setTypeService(prev => ({
      ...prev,
      label: i18n.t("TextService2")
    }));
  }, [i18n]);

  const fEmployee = () => {
    let arr = []
    employeesSelected.map((item) => {
      arr.push({ label: item.name, value: item.idEmployee })
    })
    setFormatEmployees([...arr])
  }

  const searchFilters = debounce((value, type) => {
    setFindEmployees([]);
  
    let newOpts = {
      ...autoformik.values,
      [type]: value,
      partner_id: company.value,
      page: 1,
      size: 5,
    };
  
    Object.keys(newOpts).forEach(
      (key) => (newOpts[key] === "" || newOpts[key] === null) && delete newOpts[key]
    );
  
    onGetEmployeesAdmin(newOpts);
  }, 300);

  const getMinutes = (selectedDate) => {
    const today = new Date();
    const selected = new Date(selectedDate);
  
    const isToday = today.toDateString() === selected.toDateString();
  
    if (isToday) {
      const min = new Date();
      min.setMinutes(min.getMinutes() + 5);
      const minTimeFormatted = `${min.getHours().toString().padStart(2, '0')}:${min.getMinutes().toString().padStart(2, '0')}`;
      setMinTime(minTimeFormatted);
      
      if (hourService < minTimeFormatted) {
        setHourService(minTimeFormatted);
      }
    } else {
      setMinTime("00:00");
    }
  };

  useEffect(() => {
    if(!newCreateAddressEmployee.idDB) return;

    let body = { addresses: [{ name: "Default", address: { ...newCreateAddressEmployee } }]}
    postEmployeesAdminCreateAddress(token, newCreateAddressEmployee.idDB, body)
      .then((responseAddress) => {
        onGetEmployeesAdmin()
      })
      .catch((error) => { 
        console.error("Error - postEmployeesAdminCreateAddress - ", error)
        if(error.code == 500) setErrorAlertMessage(i18n.t("ServerError"))
      })  
    
  }, [newCreateAddressEmployee]);

  const { id } = useParams();
  const [isEditMode, setIsEditMode] = useState(false);
  
  useEffect(() => {
    if (id) {
      setIsEditMode(true);
      fetchServiceRequest(id);
    }
  }, [id]);
  
  const fetchServiceRequest = async (requestId) => {
    try {
      const response = await getServiceRequestAdmin(token, requestId);
      const data = response || {};
  
      setTypeService({ 
        label: data.type === BookingType.OPEN ? i18n.t("TextService1") : data.type === BookingType.CLOSED ? i18n.t("TextService2") : data.type || "N/A", 
        value: data.type || "" 
      });
      setCompany({ label: data.partner_name || "N/A", value: data.partner_id || "" });
      setDateService(data.scheduled_start?.date || "");
      setHourService(data.scheduled_start?.time || "");
      setAditionalNote(data.info?.notes?.[0]?.message || "");
  
      const markers = [];
  
      const origin = data.info?.origin?.address;
      if (origin) {
        const originData = {
          id: TypeAddress.ORIGIN,
          description: origin.description,
          location: {
            lat: origin.latlng.latitude,
            lng: origin.latlng.longitude,
          },
          typeAddress: TypeAddress.ORIGIN,
          dragg: true,
        };
        setOriginAddressService(originData);
        setSelectedOrigin(originData.location);
        markers.push(originData);
      }
  
      const destination = data.info?.destination?.address;
      if (destination) {
        const destinationData = {
          id: TypeAddress.DESTINY,
          description: destination.description,
          location: {
            lat: destination.latlng.latitude,
            lng: destination.latlng.longitude,
          },
          typeAddress: TypeAddress.DESTINY,
          dragg: true,
        };
        setDestinyAddressService(destinationData);
        setSelectedDestiny(destinationData.location);
        markers.push(destinationData);
      }
  
      const scales = data.info?.scales || [];
      const formattedScales = scales.map((scale, index) => ({
        id: `scale-${index}`, 
        description: scale.address.description,
        location: {
          lat: scale.address.latlng.latitude,
          lng: scale.address.latlng.longitude,
        },
        typeAddress: TypeAddress.ARRAY_SCALES,
        dragg: true,
      }));
      setArrScales(formattedScales);
      markers.push(...formattedScales);
  
      setAddressesMarkers(markers);
  
      const riders = data.info?.riders || [];
      const formattedEmployees = riders.map((rider) => ({
        id: rider.id,
        name: rider.name,
        dropoff: rider.dropoff,
      }));
      setEmployeesSelectedFind(formattedEmployees);
  
    } catch (error) {
      console.error("Error getting service request:", error);
    }
  };  

  const onClickUpdateRequest = () => {
    if (!typeService.value) {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
    } else {
      let addressService = null;
      if (originAddressService.description) addressService = originAddressService;
      if (destinyAddressService.description && typeService.value === BookingType.ARRIVAL) addressService = destinyAddressService;
  
      let arr = [];
      employeesSelected.map((item) => {
        let body = {
          id: item.idEmployee,
          name: item.name,
          dropoff: {
            destination: true,
            scale_order: 0,
          },
        };
        if (typeService.value !== BookingType.CLOSED && typeService.value !== BookingType.OPEN) {
          body.is_individual_trip = item.is_individual_trip;
          body.address = {
            description: item.address.address.description,
            latlng: {
              latitude: item.address.address.location.lat,
              longitude: item.address.address.location.lon,
            },
          };
        }
        arr.push(body);
      });
  
      let formData = bodyEditGral();
      serviceEdit(formData);
    }
  };

  const onClickCreateRequest = async () => {
    if (!typeService.value) {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
      return;
    }
  
    if ((!originAddressService?.location && typeService.value !== BookingType.ARRIVAL) || 
        (!destinyAddressService?.location && typeService.value === BookingType.CLOSED)) {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
      return;
    }
  
    try {
      for (let unitIndex = 0; unitIndex < units; unitIndex++) {
        const unitEmployees = groupedEmployees[unitIndex] || [];

        const arr = [];
        let scaleCounter = 1;

        unitEmployees.forEach((item) => {
          let body = {
            id: item.idEmployee,
            name: item.name,
            cost_center_id: item.cost_center?.id || "",
            cost_center_name: item.cost_center_name || "",
            dropoff: {
              destination: true,
              scale_order: 0,
            },
          };

          arrScales.forEach((scale) => {
            if (scale.location && item.idEmployee === (scale.employeeId || scale.passenger_id)) {
              body.dropoff.destination = false;
              body.dropoff.scale_order = scaleCounter;
              scaleCounter++;
            }
          });

          if (typeService.value !== BookingType.CLOSED && typeService.value !== BookingType.OPEN) {
            body.is_individual_trip = item.is_individual_trip;
            body.address = {
              description: item.address.address.description,
              latlng: {
                latitude: item.address.address.location.lat,
                longitude: item.address.address.location.lon,
              },
            };
          }
          arr.push(body);
        });

        let formData = bodyGral();
        formData.info.riders = arr;
        formData.type = typeService.value;
        formData.info.unit_number = unitIndex + 1;

        switch (typeService.value) {
          case BookingType.OPEN:
            formData.info.origin = {
              address: {
                description: originAddressService.description.toString(),
                latlng: {
                  latitude: originAddressService.location.lat,
                  longitude: originAddressService.location.lon,
                },
              },
            };
            break;

          case BookingType.CLOSED:
            const onArrScales = arrScales
              .filter(scale =>
                scale.location &&
                (unitEmployees.some(e => e.idEmployee === (scale.employeeId || scale.passenger_id)) || !scale.employeeId)
              )
              .map((scale, index) => ({
                order: index + 1,
                address: {
                  description: scale.description,
                  latlng: {
                    latitude: scale.location.lat,
                    longitude: scale.location.lon || scale.location.lng,
                  },
                },
              }));
            formData.info.scales = onArrScales;
            formData.info.origin = {
              address: {
                description: originAddressService.description,
                latlng: {
                  latitude: originAddressService.location.lat,
                  longitude: originAddressService.location.lon,
                },
              },
            };
            formData.info.destination = {
              address: {
                description: destinyAddressService.description,
                latlng: {
                  latitude: destinyAddressService.location.lat,
                  longitude: destinyAddressService.location.lon || destinyAddressService.location.lng,
                },
              },
            };
            break;

          case BookingType.ARRIVAL:
            formData.info.destination = {
              address: {
                description: destinyAddressService.description.toString(),
                latlng: {
                  latitude: destinyAddressService.location.lat,
                  longitude: destinyAddressService.location.lon,
                },
              },
            };
            break;

          case BookingType.LEAVING:
            formData.info.origin = {
              address: {
                description: originAddressService.description.toString(),
                latlng: {
                  latitude: originAddressService.location.lat,
                  longitude: originAddressService.location.lon,
                },
              },
            };
            break;
        }

        await serviceCreate(formData);
      }
      
    } catch (error) {
      console.error("Error creating requests:", error);
      setErrorAlertMessage(i18n.t("InvalidServiceType"));
      setErrorAlert(true);
    }
  };
  
  const handleScaleAddressChange = (newAddress, index) => {
    const updatedScales = [...arrScales];
    updatedScales[index] = {
        ...updatedScales[index],
        address: {
            description: newAddress.description,
            latlng: {
                latitude: newAddress.location.lat,
                longitude: newAddress.location.lon,
            },
        },
    };
    setArrScales(updatedScales);
  };

  const bodyGral = () => {
    const body = {
      company_id: company.value.toString(),
      scheduled_start: {
        timezone: "America/Mexico_City",
        date: dateService,
        time: hourService,
      },
      info: {},
    };
    if (aditionalNote) {
      body.info.notes = [{ message: aditionalNote }];
    }
  
    if (!disableTextarea && idTag.trim() !== "") {
      body.info.cost_center = {
        id: "",
        name: idTag.trim(),
      };
    }
  
    return body;
  };

  const bodyEditGral = () => {
    const body = {
      requests: [
        {
          code: id.toString(),
          status: "UNASSIGNED",
          info: {
            type: typeService.value,
            scheduled_start: {
              timezone: "America/Mexico_City",
              date: dateService,
              time: hourService,
            },
            company_id: company.value.toString(),
            partner_name: company.label,
            origin: {
              address: {
                description: originAddressService.description,
                latlng: {
                  latitude: originAddressService.location.lat,
                  longitude: originAddressService.location.lon,
                },
              },
            },
            ...(typeService.value === BookingType.CLOSED && {
              destination: {
                address: {
                  description: destinyAddressService.description,
                  latlng: {
                    latitude: destinyAddressService.location.lat,
                    longitude: destinyAddressService.location.lon,
                  },
                },
              },
            }),
            scales: arrScales.map((item, index) => ({
              order: index + 1,
              address: {
                description: item.description,
                latlng: {
                  latitude: item.location.lat,
                  longitude: item.location.lon,
                },
              },
            })) || [],
            riders: employeesSelected.map(item => ({
              id: item.idEmployee,
              name: item.name,
              dropoff: {
                destination: true,
                scale_order: 0,
              },
            })) || [],
          },
        },
      ],
    };
  
    if (aditionalNote) {
      body.info.notes = [{ message: aditionalNote }];
    }

    return body;
  };  

  const onGetEmployeesAdmin = (newOpts = { page: 1, service: true, size: 5, partner_id: company.value }) => {
    let arr = []
    getEmployeesAdmin(token, newOpts)
      .then((response) => {
        setOpts(newOpts)
        setEmployees(response)
        setFindEmployees([...response.items])
      })
      .catch((error) => {
        console.error("Error - getEmployeesAdmin - ", error);
      })
  };

  const getCompanies = () => {
    let arr = []
    onGetOrgsAdmin()
      .then((response) => {
        response.map((item) => {
          arr.push({ label: item.name, value: item.partner_id })
        })
        setListCompanies([...arr])
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message))
      })
  };

  const groupedEmployees = chunk(employeesSelectedFind, 4);

  const onClickRemoveEmployee = (val) => {
    let updatedEmployeesSelected = [...employeesSelected];
    let updatedValidationsAddresses = [...validationsAddresses];
    let updatedFindEmployees = [...findEmployees];
    let updatedArrScales = [...arrScales];
    let updatedAddressesMarkers = [...addressesMarkers];
    let updatedTemporarySelections = {...temporarySelections};

    const findEmployee = updatedEmployeesSelected.find((opt) => opt.id === val.id);
    if (!findEmployee) return;
  
    delete updatedTemporarySelections[findEmployee.id];
  
    const findAddressVal = updatedValidationsAddresses.find(
      (opt) => opt.employee_id === val.address?.employee_id
    );
    if (findAddressVal) {
      updatedValidationsAddresses.splice(
        updatedValidationsAddresses.indexOf(findAddressVal),
        1
      );
    }
  
    updatedEmployeesSelected = updatedEmployeesSelected.filter(
      (opt) => opt.id !== val.id
    );
  
    updatedArrScales = updatedArrScales.filter(
      (scale) => scale.employeeId !== findEmployee.idEmployee
    );
    updatedAddressesMarkers = updatedAddressesMarkers.filter(
      (marker) => marker.employeeId !== findEmployee.idEmployee
    );
  
    updatedFindEmployees.push({
      id: findEmployee.idEmployee,
      identifier: findEmployee.identifier,
      name: findEmployee.name,
      depot: findEmployee.depot,
      phone: findEmployee.phone,
      cost_center: findEmployee.cost_center,
      addresses: findEmployee.addresses,
      available_trips: findEmployee.available_trips,
    });
  
    updatedEmployeesSelected.sort((a, b) => a.id - b.id);
    updatedFindEmployees.sort((a, b) => a.id - b.id);
  
    let newArrScales = [];
    let newMarkers = [];
    let newDestinyMarker = null;
    let newDestinyAddressService = null;
  
    if (updatedEmployeesSelected.length === 1) {
      const employee = updatedEmployeesSelected[0];
      const selectedAddress = updatedTemporarySelections[employee.id] || 
                            employee.selectedAddress || 
                            employee.addresses[0];
      
      if (selectedAddress) {
        newDestinyMarker = {
          id: `destiny-${employee.idEmployee}`,
          description: selectedAddress.address.description,
          location: {
            lat: parseFloat(selectedAddress.address.location.lat),
            lng: parseFloat(selectedAddress.address.location.lon || selectedAddress.address.location.lng),
          },
          dragg: true,
          typeAddress: TypeAddress.DESTINY,
          employeeId: employee.idEmployee,
          employeeName: employee.name,
        };
  
        newDestinyAddressService = {
          id: 2,
          description: selectedAddress.address.description,
          address: {
            description: selectedAddress.address.description,
            location: {
              lat: parseFloat(selectedAddress.address.location.lat),
              lng: parseFloat(selectedAddress.address.location.lon || selectedAddress.address.location.lng),
            }
          },
          location: {
            lat: parseFloat(selectedAddress.address.location.lat),
            lng: parseFloat(selectedAddress.address.location.lon || selectedAddress.address.location.lng),
          },
          typeAddress: TypeAddress.DESTINY,
          dragg: true,
          ...selectedAddress
        };
  
        newMarkers.push(newDestinyMarker);
      }
    } else if (updatedEmployeesSelected.length > 1) {
      const last = updatedEmployeesSelected[updatedEmployeesSelected.length - 1];
      const others = updatedEmployeesSelected.slice(0, -1);
  
      others.forEach((employee, index) => {
        const selectedAddress = updatedTemporarySelections[employee.id] || 
                              employee.selectedAddress || 
                              employee.addresses[0];
        
        if (selectedAddress) {
          const scaleId = index + 3;
          const scale = {
            id: scaleId,
            description: selectedAddress.address.description,
            location: {
              lat: parseFloat(selectedAddress.address.location.lat),
              lng: parseFloat(selectedAddress.address.location.lon || selectedAddress.address.location.lng),
            },
            dragg: true,
            typeAddress: TypeAddress.ARRAY_SCALES,
            employeeId: employee.idEmployee,
            employeeName: employee.name,
            stopover: true,
          };
          newArrScales.push(scale);
          newMarkers.push({
            ...scale,
            id: `scale-${scaleId}`,
            typeAddress: TypeAddress.ARRAY_SCALES,
          });
        }
      });
  
      const selectedDestinyAddress = updatedTemporarySelections[last.id] || 
                                   last.selectedAddress || 
                                   last.addresses[0];
      
      if (selectedDestinyAddress) {
        newDestinyMarker = {
          id: `destiny-${last.idEmployee}`,
          description: selectedDestinyAddress.address.description,
          location: {
            lat: parseFloat(selectedDestinyAddress.address.location.lat),
            lng: parseFloat(selectedDestinyAddress.address.location.lon || selectedDestinyAddress.address.location.lng),
          },
          dragg: true,
          typeAddress: TypeAddress.DESTINY,
          employeeId: last.idEmployee,
          employeeName: last.name,
        };
  
        newDestinyAddressService = {
          id: 2,
          description: selectedDestinyAddress.address.description,
          address: {
            description: selectedDestinyAddress.address.description,
            location: {
              lat: parseFloat(selectedDestinyAddress.address.location.lat),
              lng: parseFloat(selectedDestinyAddress.address.location.lon || selectedDestinyAddress.address.location.lng),
            }
          },
          location: {
            lat: parseFloat(selectedDestinyAddress.address.location.lat),
            lng: parseFloat(selectedDestinyAddress.address.location.lon || selectedDestinyAddress.address.location.lng),
          },
          typeAddress: TypeAddress.DESTINY,
          dragg: true,
          ...selectedDestinyAddress
        };
  
        newMarkers.push(newDestinyMarker);
      }
    }
  
    setTemporarySelections(updatedTemporarySelections);
    setEmployeesSelected(updatedEmployeesSelected);
    setEmployeesSelectedFind(updatedEmployeesSelected);
    setValidationsAddresses(updatedValidationsAddresses);
    setFindEmployees(updatedFindEmployees);
    setArrScales(newArrScales);
    setAddressesMarkers(newMarkers);
    setSelectedDestiny(newDestinyMarker);
    setDestinyAddressService(newDestinyAddressService);

    if (
      selectedOrigin &&
      newDestinyMarker &&
      newDestinyMarker.location &&
      !isNaN(newDestinyMarker.location.lat) &&
      !isNaN(newDestinyMarker.location.lng)
    ) {
      setTimeout(() => {
        calculateRoute(selectedOrigin, newDestinyMarker, newArrScales);
      }, 100);
    }
  };

  const onClickAddEmployees = (employee, isAutomaticSelection = false, isSingleUnitForMe = false) => {
    let updatedEmployeesSelected = [...employeesSelected];
    let updatedValidationsAddresses = [...validationsAddresses];
    let updatedFindEmployees = [...findEmployees];
    let updatedArrScales = [...arrScales];
    let updatedAddressesMarkers = [...addressesMarkers];
    let updatedTemporarySelections = {...temporarySelections};
  
    const existingEmployee = updatedEmployeesSelected.find(
      (opt) => opt.idEmployee === employee.id
    );
  
    if (existingEmployee && !isAutomaticSelection) {
      updatedEmployeesSelected = updatedEmployeesSelected.filter(
        (opt) => opt.idEmployee !== employee.id
      );
      updatedFindEmployees.push(employee);
  
      updatedArrScales = updatedArrScales.filter(scale => 
        !scale.employeeId || scale.employeeId !== employee.id
      );
      updatedAddressesMarkers = updatedAddressesMarkers.filter(marker => 
        !(marker.employeeId === employee.id && 
          (marker.typeAddress === TypeAddress.ARRAY_SCALES || marker.typeAddress === TypeAddress.DESTINY))
      );
      
      delete updatedTemporarySelections[employee.id];
    } else if (!existingEmployee) {
      const id = updatedEmployeesSelected.length !== 0
        ? updatedEmployeesSelected[updatedEmployeesSelected.length - 1].id + 1
        : 0;
  
      const newEmployee = {
        id: id,
        idEmployee: employee.id,
        addresses: employee.addresses,
        available_trips: employee.available_trips,
        is_individual_trip: isSingleUnitForMe,
        identifier: employee.identifier,
        name: employee.name,
        depot: employee.depot,
        phone: employee.phone,
        cost_center: employee.cost_center,
        cost_center_id: employee.cost_center?.id || "",
        cost_center_name: employee.cost_center?.name || "",
        address: employee.addresses.length === 1 ? employee.addresses[0] : {},
        dropoff: { destination: true },
        selectedAddress: employee.addresses.length > 0 ? employee.addresses[0] : null 
      };
      updatedEmployeesSelected.push(newEmployee);
  
      if (temporarySelections[employee.id]) {
        updatedTemporarySelections[employee.id] = temporarySelections[employee.id];
      }
  
      const address = employee.addresses?.[0]?.address;
  
      if (employee.addresses.length > 0 && !isSingleUnitForMe) {
        updatedEmployeesSelected.slice(0, -1).forEach((emp, idx) => {
          const empAddress = temporarySelections[emp.id] || emp.selectedAddress || emp.addresses[0];
          if (empAddress) {
            const scaleId = updatedArrScales.length > 0
              ? Math.max(...updatedArrScales.map(s => s.id)) + 1
              : 3 + idx;
  
            const scale = {
              id: scaleId,
              description: empAddress.address.description,
              location: {
                lat: parseFloat(empAddress.address.location.lat),
                lng: parseFloat(empAddress.address.location.lon || empAddress.address.location.lng),
              },
              dragg: true,
              typeAddress: TypeAddress.ARRAY_SCALES,
              employeeId: emp.idEmployee,
              employeeName: emp.name,
              stopover: true,
            };
  
            if (!updatedArrScales.some(s => s.employeeId === emp.idEmployee)) {
              updatedArrScales.push(scale);
              updatedAddressesMarkers.push({
                ...scale,
                id: `scale-${scaleId}`,
                typeAddress: TypeAddress.ARRAY_SCALES,
                location: scale.location,
              });
            }
          }
        });
  
        const selectedDestinyAddress = temporarySelections[employee.id] || 
                                     newEmployee.selectedAddress || 
                                     employee.addresses[0];
        
        const destinyMarker = {
          id: `destiny-${employee.id}`,
          description: selectedDestinyAddress.address.description,
          location: {
            lat: parseFloat(selectedDestinyAddress.address.location.lat),
            lng: parseFloat(selectedDestinyAddress.address.location.lon || selectedDestinyAddress.address.location.lng),
          },
          dragg: true,
          typeAddress: TypeAddress.DESTINY,
          employeeId: employee.id,
          employeeName: employee.name,
        };
  
        setSelectedDestiny(destinyMarker);
        
        const destinyAddressForService = {
          id: 2,
          description: selectedDestinyAddress.address.description,
          address: {
            description: selectedDestinyAddress.address.description,
            location: {
              lat: parseFloat(selectedDestinyAddress.address.location.lat),
              lng: parseFloat(selectedDestinyAddress.address.location.lon || selectedDestinyAddress.address.location.lng),
            }
          },
          location: {
            lat: parseFloat(selectedDestinyAddress.address.location.lat),
            lng: parseFloat(selectedDestinyAddress.address.location.lon || selectedDestinyAddress.address.location.lng),
          },
          typeAddress: TypeAddress.DESTINY,
          dragg: true,
          ...selectedDestinyAddress
        };
        
        setDestinyAddressService(destinyAddressForService);
        
        updatedAddressesMarkers = updatedAddressesMarkers.filter(
          marker => marker.typeAddress !== TypeAddress.DESTINY
        );
        updatedAddressesMarkers.push(destinyMarker);
  
        if (employee.addresses.length === 1 && typeService.value === BookingType.ARRIVAL) {
          updatedValidationsAddresses.push(employee.addresses[0]);
        }
      }
  
      updatedFindEmployees = updatedFindEmployees.filter(
        (emp) => emp.id !== employee.id
      );
    }
  
    setTemporarySelections(updatedTemporarySelections);
    setArrScales(updatedArrScales);
    setAddressesMarkers(updatedAddressesMarkers);
    setValidationsAddresses(updatedValidationsAddresses);
    setEmployeesSelected(updatedEmployeesSelected);
    setEmployeesSelectedFind(updatedEmployeesSelected);
    setFindEmployees(updatedFindEmployees);
  
    if (selectedOrigin && selectedDestiny && 
        selectedDestiny.location && 
        !isNaN(selectedDestiny.location.lat) && 
        !isNaN(selectedDestiny.location.lng)) {
      setTimeout(() => {
        calculateRoute(selectedOrigin, selectedDestiny, updatedArrScales);
      }, 100);
    }
  };
  
  const handleEmployeeEdit = (index, field, value) => {
    const updatedEmployees = [...editingEmployees];
    updatedEmployees[index] = {
      ...updatedEmployees[index],
      [field]: value
    };
    setEditingEmployees(updatedEmployees);
  };
  
  const onChangeTypeService = (e) => {
    setShowTypeService(false);
    setShowAddresses(true);
    setTypeService(e);
    setOriginAddressService({});
    setDestinyAddressService({});
    setUnits(1);
    setAddressesMarkers([]);
    setError('typeService', false);
  };

  const handleValidateTypeService = () => {
    if (!typeService.value) {
      setError('typeService', true);
    }
  };
  
  const onBlurUnits = (val) => {
    setUnits(val)
  };

  const fillCompany = () => {
    setCompany({ label: infoUser.partner_name, value: infoUser.partner_id });
  };
  
  const fillTypeService = () => {
    const defaultService = {
      label: i18n.t("TextService2"),
      value: BookingType.CLOSED
    };
    
    let arr = [
      { label: i18n.t("TextService1"), value: BookingType.OPEN },
      defaultService,
      // { label: i18n.t("TextService3"), value: BookingType.ARRIVAL },
      // { label: i18n.t("TextService4"), value: BookingType.LEAVING },
    ];
    
    setListTypeService([...arr]);
    
    if (!typeService.value) {
      setTypeService(defaultService);
    }
  };

  const onChangeDate = (e) => {
    const selectedDate = e[0];
    if (selectedDate) {
      setDateService(`${selectedDate.getFullYear()}-${(selectedDate.getMonth() + 1).toString().padStart(2, '0')}-${selectedDate.getDate().toString().padStart(2, '0')}`);
      setError('date', false);
    } else {
      setError('date', true);
    }
    getMinutes(selectedDate);
  };
  
  const onChangeHour = (e) => {
    const selectedHour = e[0];
    if (selectedHour) {
      setHourService(`${selectedHour.getHours().toString().padStart(2, '0')}:${selectedHour.getMinutes().toString().padStart(2, '0')}`);
      setError('hour', false);
    } else {
      setError('hour', true);
    }
  };

  const onBlurAditionalNote = (val) => {
    setShowDateHour(false)
    setShowTypeService(true)
    setAditionalNote(val)
  };

  const dropDownHidde = (val, type) => {
    setShowCompany(type === VisibilityTypes.COMPANY ? true : false)
    setShowGeneral(type === VisibilityTypes.GENERAL ? true : false)
    setShowDateHour(type === VisibilityTypes.DATE_HOUR ? true : false)
    setShowAdditionalNote(type === VisibilityTypes.ADDITIONAL_NOTE ? true : false)
    setShowTypeService(type === VisibilityTypes.TYPE_SERVICE ? true : false)
    setShowAddresses(type === VisibilityTypes.ADDRESSES ? true : false)
    setShowUnits(type === VisibilityTypes.UNITS ? true : false)
    setShowIdTag(type === VisibilityTypes.IDTAG ? true: false)
    setShowEmployees(type === VisibilityTypes.EMPLOYEES ? true : false)
    setShowScales(type === VisibilityTypes.SCALES ? true : false)
  };
  
  const validateAddresses = () => {
    setError("origin", !originAddressService.description);
    setError("destiny", !destinyAddressService.description);
  };
  
  const handleAddRowScale = () => {
    var id = 0;
    if (arrScales.length != 0) id = arrScales[arrScales.length - 1].id + 1;
    const newRowScale = {
      id: id,
      editRow: true,
      typeAddress: TypeAddress.ARRAY_SCALES,
      address: { description: null,
        location: { lat: 0, lon: 0 }
      },
      name: "",
    };
    setArrScales([...arrScales, newRowScale]);
  };
  
  const handleRemoveRowScale = (id) => {
    if (arrScales.length === 1) {
      setArrScales([
        {
          id: 0,
          latLon: false,
          passenger_id: null,
          name: null,
          typeAddress: TypeAddress.ARRAY_SCALES,
          address: {
            location: { lon: -99.1446503251791, lat: 19.46416132507601 },
          },
        },
      ]);
    } else {
      const updatedRows = arrScales.filter((row) => row.id !== id);
      const updatedAddressesMarkers = addressesMarkers.filter(
        (marker) => marker.id !== id
      );
  
      setAddressesMarkers(updatedAddressesMarkers);
      setArrScales(updatedRows);
    }
  };

  const serviceCreate = (formData) => {
    postServicesAdmin(token, formData)
      .then((response) => {
        if (response.code) {
          setServiceCode(response.code);
  
          setErrorAlert(false);
          setAlertHeader(i18n.t("SolicitedService"));
          setAlertBody(
            i18n.t("SuccessRequestServiceWithCode", {
              code: `<a href="/services/request/${response.code}">${response.code}</a>`,
            })
          );
          setShowAlertSuccess(true);
          setShowRequestData(false);
          setShowAssignedUnit(true);
        } else {
          setErrorAlert(true);
          setErrorAlertMessage(i18n.t("AssignmentFailed"));
        }
      })
      .catch((error) => {
        setErrorAlert(true);
        setErrorAlertMessage(
          JSON.stringify(error?.response?.data?.detail || error.message)
        );
        if (error.code === 500) {
          setErrorAlertMessage(i18n.t("ServerError"));
        }
      });
  };  

  const serviceEdit = (formData) => {
    putPlatformRequest(token, formData)
      .then((response) => {
        if (Array.isArray(response) && response.length > 0 && response[0].code) {
          setErrorAlert(false);
          saveToLocalStorage("notify", "true");
          saveToLocalStorage("headerText", i18n.t("UpdatedService"));
          saveToLocalStorage("bodyText", i18n.t("SuccessUpdatedService"));
          history("/services/request");
        }
      })
      .catch((error) => {
        console.error("Error - putPlatformRequest:", error);
        setErrorAlert(true);
        setErrorAlertMessage(
          JSON.stringify(error?.response?.data?.detail || error.message)
        );
  
        if (error.code === 500) {
          setErrorAlertMessage(i18n.t("ServerError"));
        }
      });
  };

  const isDisabled = useMemo(() => {
    const hasNoEmployeesOrUnits = employeesSelectedFind.length === 0 && (!units || units < 2);
    const hasNoOrigin = !originAddressService?.location;
    const hasNoDestiny = !destinyAddressService?.location;
    const shouldValidateIdTag = isPartnerAllowed(company.value || infoUser?.partner_id);
    const hasNoIdTag = shouldValidateIdTag && (!idTag || idTag.trim() === '');
  
    if (typeService.value === BookingType.OPEN) {
      return hasNoOrigin || hasNoEmployeesOrUnits || hasNoIdTag;
    }
  
    return hasNoOrigin || hasNoDestiny || hasNoEmployeesOrUnits || hasNoIdTag;
  }, [typeService.value, originAddressService?.location, destinyAddressService?.location, employeesSelectedFind, units, company.value, infoUser?.partner_id, idTag]);

  const updateEmployeeScale = (employeeId, newAddress) => {
    const updatedScales = arrScales.map(scale => 
      scale.employeeId === employeeId 
        ? {
            ...scale,
            description: newAddress.description,
            location: {
              lat: newAddress.location.lat,
              lng: newAddress.location.lon || newAddress.location.lng
            }
          }
        : scale
    );
    
    setArrScales(updatedScales);
  
    const updatedMarkers = addressesMarkers.map(marker => {
      if (marker.employeeId === employeeId && marker.typeAddress === TypeAddress.ARRAY_SCALES) {
        const updatedScale = updatedScales.find(s => s.employeeId === employeeId);
        return {
          ...marker,
          ...updatedScale
        };
      }
      return marker;
    });
  
    setAddressesMarkers(updatedMarkers);
  
    if (selectedOrigin && selectedDestiny) {
      calculateRoute(selectedOrigin, selectedDestiny, updatedScales);
    }
  };

  const handlePlateSearch = async (query) => {
    setSearchPlateQuery(query);
    
    if (query.length >= 2) {
      setIsLoadingPlates(true);
      try {
        const response = await getPlatesOnboard("PT", 1, 100, query);
        
        const filteredPlates = response.items.map(driver => {
          return {
            plate: driver.vehicle?.plate || '',
            sub: driver.driver?.sub || '',
            full_name: driver.driver?.full_name || '',
            vehicle: driver.vehicle || null
          };
        });
        
        setPlateResults(filteredPlates);
        setShowPlateDropdown(true);
      } catch (error) {
        console.error("Error getting plates:", error);
        setPlateResults([]);
      } finally {
        setIsLoadingPlates(false);
      }
    } else {
      setPlateResults([]);
      setShowPlateDropdown(false);
    }
  };

  const handlePlateSelect = (plateInfo) => {
    setSelectedPlate(plateInfo);
    setSearchPlateQuery(plateInfo.plate);
    setShowPlateDropdown(false);
  };

  const assignPlateToService = async (service, plateInfo) => {
    setErrorAlertHeader(i18n.t("AssignAlertError"));
    
    if (!service || !plateInfo) {
      setErrorAlertMessage(i18n.t("ServiceOrPlateMissing"));
      setErrorAlert(true);
      return false;
    }
  
    try {
      const body = {
        assigns: [{
          sub: plateInfo.sub,
          plate: plateInfo.plate,
          code: service.code
        }]
      };
  
      const response = await postServicesAssignAdmin(token, body);
  
      if (response.assigns && response.assigns[0].status === "SUCCESSFUL") {
        return true;
      }
      
      setErrorAlertMessage(i18n.t("AssignmentFailed"));
      setErrorAlert(true);
      return false;
      
    } catch (error) {
      console.error("Error in assignPlateToService:", error);

      if (error?.response?.status === 409) {
        setErrorAlertMessage(i18n.t("OperatorAlreadyAssigned"));
      } else {
        setErrorAlertMessage(i18n.t("AssignmentFailed"));
      }
      
      setErrorAlert(true);
      return false;
    }
  };

  const handleCloseErrorAlert = () => {
    setErrorAlert(false);
    setErrorAlertHeader(i18n.t("ServiceAlertError"));
  };

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink title={i18n.t("Services")} link='/services/request' breadcrumbItem={i18n.t("ServiceRequest")} />
          <div className="container-fluid">
            <Card>
              <Row className="p-3">
                <Col xxl={6} md={6} xs={12} className="">
                  <Link 
                    className={`request-step-title ${continueClicked ? 'completed-step' : ''}`}
                    onClick={() => !continueClicked && setShowRequestData(!showRequestData)}
                    style={{ pointerEvents: continueClicked ? 'none' : 'auto' }}
                  >
                    <h6 className="request-step-title">
                      <span className={`request-number-circle ${continueClicked ? 'completed-circle' : ''}`}>
                        1
                      </span>
                      {i18n.t("RequestData")} {serviceCode && `(${serviceCode})`}
                      <i className={`${showRequestData ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon`} />
                    </h6>
                  </Link>
                  {showRequestData && (
                    <>
                      {!showEmployees && <hr />}
                      {!showEmployees && (
                        <Col xxl={12} md={12} xs={12}>
                          <Link 
                            className="request-create-title"
                            onClick={() => company.value && dropDownHidde(!showDateHour, VisibilityTypes.DATE_HOUR)}
                          >
                            <h6 className="request-create-title">
                              {`${i18n.t("DateHourService")} ${(dateService && hourService) ? `(${dateService} - ${hourService})` : ''}`}
                              <i className={ `${showDateHour ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` } />
                            </h6>
                          </Link>
                          <p className="request-create-text">{i18n.t("SelectDateHourService")}</p>
                          {showDateHour && (
                            <Row>
                              <Col xxl={6} md={6} xs={12} className="pt-1">
                                <div className="form-group mb-3">
                                <Label>{i18n.t("Date")}</Label>
                                  <div className="custom-input">
                                    <Flatpickr
                                      className="form-control d-block"
                                      placeholder={i18n.t("SelectDate")}
                                      value={dateService}
                                      onChange={(e) => onChangeDate(e)}
                                      options={{
                                        minDate: "today",
                                        altInput: true,
                                        altFormat: "d/m/Y",
                                        dateFormat: "Y-m-d",
                                        defaultDate: new Date()
                                      }}
                                    />
                                    <i className="mdi mdi-calendar-outline input-icon" />
                                  </div>
                                  {errors.date && (
                                    <span className="error-message">
                                      <i className="fa fa-exclamation-circle" />
                                      {i18n.t("DateError")}
                                    </span>
                                  )}
                                </div>
                              </Col>
                              <Col xxl={6} md={6} xs={12} className="pt-1">
                                <div className="form-group mb-3">
                                <Label>{i18n.t("Hour")}</Label>
                                <div className="custom-input">
                                  <Flatpickr
                                    className="form-control d-block"
                                    placeholder={i18n.t("SelectHour")}
                                    value={hourService}
                                    onChange={(e) => onChangeHour(e)}
                                    options={{
                                      enableTime: true,
                                      noCalendar: true,
                                      dateFormat: "H:i",
                                      time_24hr: true,
                                      minTime: (() => {
                                        const now = new Date();
                                        const selected = new Date(dateService + "T00:00");
                                        if (now.toDateString() === selected.toDateString()) {
                                          now.setMinutes(now.getMinutes() + 5);
                                          return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
                                        }
                                        return "00:00";
                                      })(),
                                      defaultDate: (() => {
                                        const defaultDate = new Date();
                                        defaultDate.setMinutes(defaultDate.getMinutes() + 5);
                                        return defaultDate;
                                      })(),
                                    }}
                                  />
                                  <i className="mdi mdi-clock-outline input-icon" />
                                </div>
                                  {errors.hour && (
                                    <span className="error-message">
                                      <i className="fa fa-exclamation-circle" />
                                      {i18n.t("HourError")}
                                    </span>
                                  )}
                                </div>
                              </Col>
                            </Row>
                          )}
                        </Col>
                      )}
                      {!showEmployees && <hr />}
                      {!showEmployees && (
                        <Col xxl={12} md={12} xs={12} style={{ opacity: 0, height: 0, overflow: 'hidden' }}>
                          <Link 
                            className="request-create-title"
                            onClick={() => (dateService && hourService) && dropDownHidde(!showTypeService, VisibilityTypes.TYPE_SERVICE)}
                          >
                            <h6 className="request-create-title">
                              { `${i18n.t("TypeService")} ${typeService.label ? `(${typeService.label})` : ""} ` }
                              <i className={ `${showTypeService ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                            </h6>
                          </Link>
                          <p className="request-create-text" htmlFor="companyInput">
                            {i18n.t("SelectTypeService")}
                          </p>
                          {showTypeService && (
                            <Card className="custom-select-card">
                              <Select
                                name="typeService"
                                placeholder={i18n.t("SelectTheTypeService")}
                                value={listTypeService.filter((c) => c.value == typeService.value)}
                                options={listTypeService}
                                className="select2-selection"
                                onChange={(e) => onChangeTypeService(e)}
                                onBlur={handleValidateTypeService}
                              />
                              {errors.typeService && (
                                <span className="error-message">
                                  <i className="fa fa-exclamation-circle"></i>
                                  {i18n.t("TypeServiceError")}
                                </span>
                              )}
                            </Card>
                          )}
                        </Col>
                      )}
                      {!showEmployees && (
                        <Col xxl={12} md={12} xs={12}>
                          <Link 
                            className="request-create-title"
                            onClick={() => {
                              typeService.value && dropDownHidde(!showAddresses, VisibilityTypes.ADDRESSES);
                              validateAddresses();
                            }}
                          >
                            <h6 className="request-create-title">
                              {`${i18n.t("Addresses")} ${(originAddressService.location || destinyAddressService.location) ? `(${i18n.t("ShowMore")})` : ""}`}
                              <i className={ `${showAddresses ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` } />
                            </h6>
                          </Link>
                          {!showAddresses && (
                            <p className="request-create-text" htmlFor="companyInput">
                              {i18n.t("SelectAddresses")}
                            </p>
                          )}
                          {showAddresses && (
                            <Row>
                              {typeService.value === BookingType.ARRIVAL ? null : (
                                <Col xxl={6} xl={6} xs={12} className="address-input">
                                  <p className="request-create-text" htmlFor="companyInput">
                                    {i18n.t("TextOpenRequestAddress")}
                                  </p>
                                  <PlacesServices
                                    selectedOrigin={selectedOrigin}
                                    setAddressesMarkers={setAddressesMarkers}
                                    addressesMarkers={addressesMarkers}
                                    selectedAddress={originAddressService}
                                    setSelectedAddress={setOriginAddressService}
                                    typeAddress={TypeAddress.ORIGIN}
                                    setSelectedOrigin={setSelectedOrigin}
                                    disabled={false}
                                    titleAdressDestiny={titleAdressDestiny}
                                    setNameTitleDestiny={setNameTitleDestiny}
                                    titleAdressOrigin={titleAdressOrigin}
                                    setNameTitleOrigin={setNameTitleOrigin}
                                    setOnFocusAddress={setOnFocusAddress}
                                    id={"originAddress"}
                                    companie={Number(company.value)}
                                  />
                                  {errors.origin && (
                                    <h5 className="error-message">
                                      <i className="fa fa-exclamation-circle" />
                                      {i18n.t("OriginError")}
                                    </h5>
                                  )}
                                </Col>
                              )}
                            </Row>
                          )}
                        </Col>
                      )}
                    </>
                  )}
                  {!showEmployees && (
                    <>
                      {(<hr/>)}
                      {(typeService.value === BookingType.OPEN) && (
                        <Col xxl={12} md={12} xs={12}>
                          <Link 
                            className="request-create-title"
                            onClick={() => (originAddressService.description) && dropDownHidde(!showUnits, VisibilityTypes.UNITS)}
                          >
                            <h6 className="request-create-title">
                              {`${i18n.t("UnitsNumber")} ${ units ? `(${units})` : ''} `}
                              <i className={ `${showUnits ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}` } />
                            </h6>
                          </Link>
                          <p className="request-create-text" htmlFor="companyInput">
                            {i18n.t("SelectUnits", { number: 3 })}
                          </p>
                          {showUnits && (
                            <Row>
                              <Col xxl={2} md={2} xs={2}>
                              <p className="request-units-text single-line-text" htmlFor="companyInput">
                                {i18n.t("Units")}
                              </p>
                                <Input
                                  type="number"
                                  className="form-input units-input"
                                  defaultValue={units}
                                  onBlur={(e) => onBlurUnits(e.target.value)}
                                  placeholder={i18n.t("WriteUnit")}
                                  min={1}
                                />
                              </Col>
                            </Row>
                          )}
                        </Col>
                      )}
                      {showNextBlock && (<hr/>)}
                    </>
                  )}
                  {showRequestData && (typeService.value == BookingType.CLOSED || (typeService.value === BookingType.OPEN)) && ( 
                    <Col xxl={12} md={12} xs={12}>
                      <Link className="request-create-title">
                        <h6 className="request-create-title">
                          { `${i18n.t("Employees")} ${ employeesSelectedFind.length != 0 ? `(${i18n.t("ShowMore")})` : ''} ` }
                          <i className={ `${showEmployees ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }  />
                        </h6>
                      </Link>
                      <p className={`request-create-text ${showEmployees}`}>
                        {i18n.t("SelectEmployees", { number: 4 })}
                      </p>
                      {(
                        <Row>
                          <hr/>
                          <Col xxl={12} xl={12} xs={12}>
                            {(!isEditing &&
                              <>
                                <h6 className="request-create-title">
                                  {i18n.t("AvailableEmployees")}
                                </h6>
                                {!showEmployeesAvailable && !isEditing && (
                                  <div className="table-responsive">
                                    <Col xxl={12} md={12} xs={12} className="pt-2 pb-2 bg-light d-flex text-center">
                                      <Col xxl={5} md={5} xs={5} className=""/>
                                      <Col xxl={7} md={7} xs={7} className="row">
                                        <Col xxl={12} md={12} xs={12} className="">
                                          <div className="flex-inputs">
                                            <Input
                                              type="text"
                                              name="search"
                                              className="employees-search-input"
                                              id="searchInput"
                                              placeholder={i18n.t("SearchName")}
                                              value={autoformik.values.search}
                                              onChange={(e) => {
                                                autoformik.handleChange(e);
                                                searchFilters(e.target.value, "name");
                                              }}
                                              invalid={autoformik.touched.search && autoformik.errors.search}
                                            />
                                            {autoformik.errors.search && autoformik.touched.search && (
                                              <FormFeedback type="invalid">
                                                {autoformik.errors.search}
                                              </FormFeedback>
                                            )}
                                          </div>
                                        </Col>
                                      </Col>
                                    </Col>
                                    <Table className="table table-responsive">
                                      <thead>
                                        <tr>
                                          <th className="bg-light">{i18n.t("Name")}</th>
                                          <th className="bg-light">{i18n.t("Address")}</th>
                                          <th className="bg-light">{i18n.t("Action")}</th>
                                        </tr>
                                      </thead>
                                      {isLoading ? null :
                                        <tbody>
                                          {map(findEmployees, (employee, key) => (
                                            <tr key={key}>
                                              <td>{employee.name}</td>                                          
                                              <td>
                                                {employee.addresses.length > 0 ? employee.addresses[0].address.description : i18n.t("NoAddressRegistered")}
                                              </td>
                                              <td>
                                                <div className="d-flex gap-3">
                                                  <button
                                                    disabled={
                                                      (employee.cost_center_id
                                                        ? employee.available_trips === 0
                                                        : false) ||
                                                      groupedEmployees.reduce((total, group) => total + group.length, 0) >= 4 * units
                                                    }
                                                    className="btn btn-users fs-8"
                                                    onClick={() => 
                                                      (!employee.cost_center_id || employee.available_trips !== 0) && onClickAddEmployees(employee)
                                                    }
                                                  >
                                                    {i18n.t("Add")}
                                                  </button>
                                                </div>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      }
                                    </Table>
                                    {isLoading ? (
                                      <Spinners setLoading={setLoading} />
                                    ) : (
                                      <StyledPagination
                                        pages={employees.pages}
                                        setLoading={setLoading}
                                        token={token}
                                        viewPaginations={5}
                                        listTable={setFindEmployees}
                                        id={null}
                                        methodCustom={getEmployeesAdmin}
                                        opts={opts}
                                        page={employees.page}
                                        total={employees.total}
                                        size={employees.size}
                                        paginationDiv="col-lg-12"
                                        paginationClass="pagination pagination-rounded justify-content-end mt-3 mb-4 pb-1"
                                      />
                                    )}
                                  </div>
                                )}
                                <div className="request-separator" />
                              </>
                            )}
                          </Col>
                          <Col xxl={12} md={12} xs={12}>
                          {(!isEditing &&
                            <>
                              {groupedEmployees.slice(0, units).map((group, index) => (
                                <div key={index}>
                                  <h6 className="request-create-title" style={{ cursor: 'pointer' }}>
                                    {i18n.t("SelectedEmployees")} {`(${i18n.t("Employees")} ${group.length}/4)`}
                                  </h6>
                                  {(
                                    <div className="table-responsive pt-3">
                                      <Table className="table table-responsive">
                                        <thead>
                                          <tr>
                                            <th className="bg-light">{i18n.t("Name")}</th>
                                            <th className="bg-light">{i18n.t("Address")}</th>
                                            <th className="bg-light">{i18n.t("Actions")}</th>
                                          </tr>
                                        </thead>
                                        {isLoading ? null : (
                                          <tbody>
                                            {map(group, (employee, key) => (
                                              <tr key={key}>
                                                <td>{employee.name}</td>
                                                <td>
                                                  {editingAddressForEmployee[employee.id] ? (
                                                    <>
                                                      <Places
                                                        selected={null}
                                                        setSelected={() => {}}
                                                        setHiddenOne={() => {}}
                                                        disabled={false}
                                                        id={`employee-address-${employee.id}`}
                                                        placeholder={i18n.t("WriteAddress")}
                                                        setTitleAdress={() => {}}
                                                        typeAddress="predefined"
                                                        selectedAddress={tempAddress[employee.id] || employee.selectedAddress?.address || { description: "", location: null }}
                                                        setSelectedAddress={(newAddress) => {
                                                          setTempAddress(prev => ({
                                                            ...prev,
                                                            [employee.id]: newAddress
                                                          }));
                                                          setNewAddress(newAddress);
                                                          setSelectedEmployeeId(employee.idEmployee);                                                         
                                                          handleEmployeeEdit(
                                                            editingEmployees.findIndex(e => e.id === employee.id), 
                                                            "selectedAddress", 
                                                            { 
                                                              id: "temp-" + Date.now(),
                                                              address: newAddress 
                                                            }
                                                          );
                                                        }}
                                                        setRowsScale={() => {}}
                                                        rowsScale={[]}
                                                        addressRow={null}
                                                        setHiddenSecond={() => {}}
                                                        servicesView={false}
                                                        editAddress={true}
                                                      />
                                                    </>
                                                  ) : employee.addresses?.length > 0 ? (
                                                    <Select
                                                      name="employeeAddress"
                                                      placeholder={i18n.t("SelectAddress")}
                                                      menuPortalTarget={document.body}
                                                      menuPosition="absolute"
                                                      styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                                        option: (base, state) => ({
                                                          ...base,
                                                          backgroundColor: state.isSelected
                                                            ? '#596DDE'
                                                            : state.isFocused
                                                            ? '#F2F2F2'
                                                            : 'white',
                                                          color: state.isSelected ? 'white' : 'black',
                                                          cursor: 'pointer',
                                                        }),
                                                      }}
                                                      value={employee.addresses
                                                        .map(addr => ({
                                                          value: addr.id,
                                                          label: addr.address.description
                                                        }))
                                                        .find(option => {
                                                          if (temporarySelections[employee.id]?.id) {
                                                            return option.value === temporarySelections[employee.id]?.id;
                                                          }
                                                          if (employee.selectedAddress?.id) {
                                                            return option.value === employee.selectedAddress?.id;
                                                          }
                                                          if (employee.addresses.length > 0) {
                                                            return option.value === employee.addresses[0]?.id;
                                                          }
                                                          return false;
                                                        })
                                                      }
                                                      options={employee.addresses.map(addr => ({
                                                        value: addr.id,
                                                        label: addr.address.description
                                                      }))}
                                                      className="select2-selection"
                                                      onChange={(selectedOption) => {
                                                        if (!selectedOption) return;
                                                        
                                                        const selectedAddr = employee.addresses.find(
                                                          addr => addr.id === selectedOption.value
                                                        );
                                                    
                                                        if (selectedAddr) {
                                                          const isDestination = employeesSelected.at(-1)?.idEmployee === employee.idEmployee;
                                                        
                                                          setTemporarySelections(prev => ({
                                                            ...prev,
                                                            [employee.id]: selectedAddr
                                                          }));
                                                      
                                                          handleEmployeeEdit(
                                                            employeesSelected.findIndex(e => e.id === employee.id), 
                                                            "selectedAddress", 
                                                            selectedAddr
                                                          );
                                                        
                                                          if (isDestination) {
                                                            const newDestinyMarker = {
                                                              id: `destiny-${employee.id}`,
                                                              description: selectedAddr.address.description,
                                                              location: {
                                                                lat: parseFloat(selectedAddr.address.location.lat),
                                                                lng: parseFloat(selectedAddr.address.location.lon || selectedAddr.address.location.lng),
                                                              },
                                                              dragg: true,
                                                              typeAddress: TypeAddress.DESTINY,
                                                              employeeId: employee.id,
                                                              employeeName: employee.name,
                                                            };
                                                          
                                                            setSelectedDestiny(newDestinyMarker);
                                                          
                                                            const destinyAddressForService = {
                                                              id: 2,
                                                              description: selectedAddr.address.description,
                                                              address: {
                                                                description: selectedAddr.address.description,
                                                                location: {
                                                                  lat: parseFloat(selectedAddr.address.location.lat),
                                                                  lng: parseFloat(selectedAddr.address.location.lon || selectedAddr.address.location.lng),
                                                                }
                                                              },
                                                              location: {
                                                                lat: parseFloat(selectedAddr.address.location.lat),
                                                                lng: parseFloat(selectedAddr.address.location.lon || selectedAddr.address.location.lng),
                                                              },
                                                              typeAddress: TypeAddress.DESTINY,
                                                              dragg: true,
                                                              ...selectedAddr
                                                            };
                                                          
                                                            setDestinyAddressService(destinyAddressForService);
                                                          
                                                            setAddressesMarkers(prev => [
                                                              ...prev.filter(marker => 
                                                                !(marker.typeAddress === TypeAddress.DESTINY)
                                                              ),
                                                              newDestinyMarker
                                                            ]);
                                                          
                                                            if (selectedOrigin && newDestinyMarker.location &&
                                                                !isNaN(newDestinyMarker.location.lat) &&
                                                                !isNaN(newDestinyMarker.location.lng)) {
                                                              try {
                                                                calculateRoute(selectedOrigin, newDestinyMarker, arrScales);
                                                              } catch (routeError) {
                                                                console.warn("Error calculating route:", routeError);
                                                              }
                                                            }
                                                          } else {
                                                            updateEmployeeScale(employee.idEmployee, selectedAddr.address);
                                                          }
                                                        }
                                                      }}
                                                      getOptionValue={(option) => option.value}
                                                      getOptionLabel={(option) => option.label}
                                                    />
                                                  ) : (
                                                    i18n.t("NoAddressRegistered")
                                                  )}
                                                </td>
                                                <td>
                                                  <div className="d-flex gap-3">
                                                    {editingAddressForEmployee[employee.id] && (
                                                      <>
                                                        <button
                                                          className="btn btn-link text-success p-0"
                                                          onClick={async () => {
                                                            if (newAddress && employee.idEmployee) {
                                                              try {
                                                                if (!newAddress.description || !newAddress.location) {
                                                                  console.error("Incomplete address", newAddress);
                                                                  return;
                                                                }

                                                                const payload = {
                                                                  addresses: [
                                                                    {
                                                                      name: "Dirección Adicional",
                                                                      address: {
                                                                        location: {
                                                                          lat: newAddress.location.lat,
                                                                          lon: newAddress.location.lng || newAddress.location.lon
                                                                        },
                                                                        description: newAddress.description
                                                                      }
                                                                    }
                                                                  ]
                                                                };

                                                                const response = await postEmployeesAdminCreateAddress(
                                                                  token,
                                                                  employee.idEmployee,
                                                                  payload
                                                                );

                                                                const newAddressEntry = {
                                                                  id: response.id,
                                                                  address: {
                                                                    description: newAddress.description,
                                                                    location: {
                                                                      lat: newAddress.location.lat,
                                                                      lon: newAddress.location.lng || newAddress.location.lon
                                                                    }
                                                                  },
                                                                };

                                                                const updateEmployeeInState = (prevState) => {
                                                                  return prevState.map(emp => {
                                                                    if (emp.id === employee.id) {
                                                                      return {
                                                                        ...emp,
                                                                        addresses: [...(emp.addresses || []), newAddressEntry],
                                                                        selectedAddress: newAddressEntry
                                                                      };
                                                                    }
                                                                    return emp;
                                                                  });
                                                                };

                                                                setEmployeesSelectedFind(updateEmployeeInState);
                                                                setEditingEmployees(updateEmployeeInState);
                                                                setEmployeesSelected(updateEmployeeInState);

                                                                setTemporarySelections(prev => ({
                                                                  ...prev,
                                                                  [employee.id]: newAddressEntry
                                                                }));

                                                                setEditingAddressForEmployee(prev => ({
                                                                  ...prev,
                                                                  [employee.id]: false
                                                                }));
                                                                setNewAddress(null);
                                                                setSelectedEmployeeId(null);
                                                                setTempAddress(prev => {
                                                                  const newTemp = {...prev};
                                                                  delete newTemp[employee.id];
                                                                  return newTemp;
                                                                });

                                                                const isLastEmployee = employeesSelected.at(-1)?.id === employee.id;
                                                                
                                                                if (isLastEmployee) {
                                                                  const previousLastEmployee = employeesSelected[employeesSelected.length - 2];
                                                                  if (previousLastEmployee) {
                                                                    const previousAddress = temporarySelections[previousLastEmployee.id] || 
                                                                                          previousLastEmployee.selectedAddress || 
                                                                                          previousLastEmployee.addresses[0];
                                                                    
                                                                    if (previousAddress) {
                                                                      const existingScaleIndex = arrScales.findIndex(
                                                                        scale => scale.employeeId === previousLastEmployee.idEmployee
                                                                      );
                                                                      
                                                                      if (existingScaleIndex >= 0) {
                                                                        const updatedScales = [...arrScales];
                                                                        updatedScales[existingScaleIndex] = {
                                                                          ...updatedScales[existingScaleIndex],
                                                                          description: previousAddress.address.description,
                                                                          location: {
                                                                            lat: parseFloat(previousAddress.address.location.lat),
                                                                            lng: parseFloat(previousAddress.address.location.lon || previousAddress.address.location.lng)
                                                                          }
                                                                        };
                                                                        setArrScales(updatedScales);
                                                                        
                                                                        setAddressesMarkers(prev => [
                                                                          ...prev.filter(marker => 
                                                                            !(marker.employeeId === previousLastEmployee.idEmployee && 
                                                                              marker.typeAddress === TypeAddress.ARRAY_SCALES)
                                                                          ),
                                                                          {
                                                                            id: `scale-${updatedScales[existingScaleIndex].id}`,
                                                                            description: previousAddress.address.description,
                                                                            location: {
                                                                              lat: parseFloat(previousAddress.address.location.lat),
                                                                              lng: parseFloat(previousAddress.address.location.lon || previousAddress.address.location.lng)
                                                                            },
                                                                            dragg: true,
                                                                            typeAddress: TypeAddress.ARRAY_SCALES,
                                                                            employeeId: previousLastEmployee.idEmployee,
                                                                            employeeName: previousLastEmployee.name,
                                                                            stopover: true
                                                                          }
                                                                        ]);
                                                                      } else {
                                                                        const newScale = {
                                                                          id: arrScales.length > 0 ? Math.max(...arrScales.map(s => s.id)) + 1 : 3,
                                                                          description: previousAddress.address.description,
                                                                          location: {
                                                                            lat: parseFloat(previousAddress.address.location.lat),
                                                                            lng: parseFloat(previousAddress.address.location.lon || previousAddress.address.location.lng)
                                                                          },
                                                                          dragg: true,
                                                                          typeAddress: TypeAddress.ARRAY_SCALES,
                                                                          employeeId: previousLastEmployee.idEmployee,
                                                                          employeeName: previousLastEmployee.name,
                                                                          stopover: true
                                                                        };
                                                                        
                                                                        setArrScales([...arrScales, newScale]);
                                                                        setAddressesMarkers(prev => [
                                                                          ...prev,
                                                                          {
                                                                            ...newScale,
                                                                            id: `scale-${newScale.id}`
                                                                          }
                                                                        ]);
                                                                      }
                                                                    }
                                                                  }

                                                                  const newDestinyMarker = {
                                                                    id: `destiny-${employee.id}`,
                                                                    description: newAddressEntry.address.description,
                                                                    location: {
                                                                      lat: parseFloat(newAddressEntry.address.location.lat),
                                                                      lng: parseFloat(newAddressEntry.address.location.lon)
                                                                    },
                                                                    dragg: true,
                                                                    typeAddress: TypeAddress.DESTINY,
                                                                    employeeId: employee.id,
                                                                    employeeName: employee.name,
                                                                  };

                                                                  setSelectedDestiny(newDestinyMarker);
                                                                  
                                                                  const destinyAddressForService = {
                                                                    id: 2,
                                                                    description: newAddressEntry.address.description,
                                                                    address: {
                                                                      description: newAddressEntry.address.description,
                                                                      location: {
                                                                        lat: parseFloat(newAddressEntry.address.location.lat),
                                                                        lng: parseFloat(newAddressEntry.address.location.lon)
                                                                      }
                                                                    },
                                                                    location: {
                                                                      lat: parseFloat(newAddressEntry.address.location.lat),
                                                                      lng: parseFloat(newAddressEntry.address.location.lon)
                                                                    },
                                                                    typeAddress: TypeAddress.DESTINY,
                                                                    dragg: true,
                                                                    ...newAddressEntry
                                                                  };
                                                                  
                                                                  setDestinyAddressService(destinyAddressForService);
                                                                  
                                                                  setAddressesMarkers(prev => [
                                                                    ...prev.filter(marker => 
                                                                      !(marker.typeAddress === TypeAddress.DESTINY)
                                                                    ),
                                                                    newDestinyMarker
                                                                  ]);
                                                                  
                                                                  if (selectedOrigin && newDestinyMarker.location &&
                                                                      !isNaN(newDestinyMarker.location.lat) &&
                                                                      !isNaN(newDestinyMarker.location.lng)) {
                                                                    try {
                                                                      calculateRoute(selectedOrigin, newDestinyMarker, arrScales);
                                                                    } catch (routeError) {
                                                                      console.warn("Error calculating route:", routeError);
                                                                    }
                                                                  }
                                                                } else {
                                                                  const existingScaleIndex = arrScales.findIndex(
                                                                    scale => scale.employeeId === employee.idEmployee
                                                                  );
                                                                  
                                                                  if (existingScaleIndex >= 0) {
                                                                    const updatedScales = [...arrScales];
                                                                    updatedScales[existingScaleIndex] = {
                                                                      ...updatedScales[existingScaleIndex],
                                                                      description: newAddressEntry.address.description,
                                                                      location: {
                                                                        lat: parseFloat(newAddressEntry.address.location.lat),
                                                                        lng: parseFloat(newAddressEntry.address.location.lon)
                                                                      }
                                                                    };
                                                                    setArrScales(updatedScales);                                                                   
                                                                    setAddressesMarkers(prev => [
                                                                      ...prev.filter(marker => 
                                                                        !(marker.employeeId === employee.idEmployee && 
                                                                          marker.typeAddress === TypeAddress.ARRAY_SCALES)
                                                                      ),
                                                                      {
                                                                        id: `scale-${updatedScales[existingScaleIndex].id}`,
                                                                        description: newAddressEntry.address.description,
                                                                        location: {
                                                                          lat: parseFloat(newAddressEntry.address.location.lat),
                                                                          lng: parseFloat(newAddressEntry.address.location.lon)
                                                                        },
                                                                        dragg: true,
                                                                        typeAddress: TypeAddress.ARRAY_SCALES,
                                                                        employeeId: employee.idEmployee,
                                                                        employeeName: employee.name,
                                                                        stopover: true
                                                                      }
                                                                    ]);
                                                                  } else {
                                                                    const newScale = {
                                                                      id: arrScales.length > 0 ? Math.max(...arrScales.map(s => s.id)) + 1 : 3,
                                                                      description: newAddressEntry.address.description,
                                                                      location: {
                                                                        lat: parseFloat(newAddressEntry.address.location.lat),
                                                                        lng: parseFloat(newAddressEntry.address.location.lon)
                                                                      },
                                                                      dragg: true,
                                                                      typeAddress: TypeAddress.ARRAY_SCALES,
                                                                      employeeId: employee.idEmployee,
                                                                      employeeName: employee.name,
                                                                      stopover: true
                                                                    };
                                                                    
                                                                    setArrScales([...arrScales, newScale]);
                                                                    setAddressesMarkers(prev => [
                                                                      ...prev,
                                                                      {
                                                                        ...newScale,
                                                                        id: `scale-${newScale.id}`
                                                                      }
                                                                    ]);
                                                                  }
                                                                  
                                                                  if (selectedDestiny?.location) {
                                                                    try {
                                                                      calculateRoute(selectedOrigin, selectedDestiny, arrScales);
                                                                    } catch (routeError) {
                                                                      console.warn("Error calculating route:", routeError);
                                                                    }
                                                                  }
                                                                }

                                                              } catch (error) {
                                                                console.error("Error saving address:", error);
                                                                if (!error.message.includes("calculateRoute")) {
                                                                  setErrorAlert(true);
                                                                  setErrorAlertMessage(error.response?.data?.detail || error.message);
                                                                }
                                                              }
                                                            } else {
                                                              console.warn("No address or employee selected", {
                                                                newAddress,
                                                                employeeId: employee.id,
                                                              });
                                                            }
                                                          }}
                                                          disabled={!newAddress?.description}
                                                        >
                                                          <i className="mdi mdi-check-circle-outline font-size-18" id="checktooltip" />
                                                          <UncontrolledTooltip placement="top" target="checktooltip">
                                                            {i18n.t("Add")}
                                                          </UncontrolledTooltip>
                                                        </button>
                                                        <button
                                                        className="btn btn-link text-danger p-0"
                                                        onClick={() => {
                                                          setEditingAddressForEmployee(prev => ({
                                                            ...prev,
                                                            [employee.id]: false
                                                          }));
                                                          setTempAddress(prev => {
                                                            const newTemp = {...prev};
                                                            delete newTemp[employee.id];
                                                            return newTemp;
                                                          });
                                                        }}
                                                      >
                                                        <i className="mdi mdi-cancel font-size-18" id="canceledtooltip" />
                                                        <UncontrolledTooltip placement="top" target="canceledtooltip">
                                                          {i18n.t("Cancel")}
                                                        </UncontrolledTooltip>
                                                      </button>
                                                    </>
                                                    )}
                                                    {!editingAddressForEmployee[employee.id] && (
                                                      <>
                                                        <button
                                                          disabled={employee.cost_center_id ? employee.available_trips === 0 : false}
                                                          className="btn btn-link text-danger p-0"
                                                          onClick={() => onClickRemoveEmployee(employee)}
                                                        >
                                                          <i className="mdi mdi-delete font-size-18" id="removetooltip" />
                                                          <UncontrolledTooltip placement="top" target="removetooltip">
                                                            {i18n.t("Remove")}
                                                          </UncontrolledTooltip>
                                                        </button>
                                                        <button
                                                          className="btn btn-link text-success p-0"
                                                          onClick={() => {
                                                            setEditingAddressForEmployee(prev => ({
                                                              ...prev,
                                                              [employee.id]: true
                                                            }));
                                                          }}
                                                        >
                                                          <i className="mdi mdi-plus-circle font-size-18" id="addaddresstooltip" />
                                                          <UncontrolledTooltip placement="top" target="addaddresstooltip">
                                                            {i18n.t("Add")}
                                                          </UncontrolledTooltip>
                                                        </button>
                                                      </>
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        )}
                                      </Table>
                                    </div>
                                  )}
                                </div>
                              ))}
                              </>
                            )}             
                          </Col>
                        </Row>
                      )}
                    </Col>
                  )}
                  {showRequestData && (<hr/>)}
                  {!showEmployees && showRequestData && (
                    <Col xxl={12} md={12} xs={12}>
                      <Link 
                        className="request-create-title"
                        onClick={() => (dateService && hourService) && dropDownHidde(!showAdditionalNote, VisibilityTypes.ADDITIONAL_NOTE)}
                      >
                        <h6 className="request-create-title">
                          {i18n.t("References")}
                          <i className={ `${showAdditionalNote ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` } />
                        </h6>
                      </Link>
                      <p className="request-create-text" htmlFor="companyInput">
                        {i18n.t("DescAditionalNote")}
                      </p>
                      {showAdditionalNote && (
                        <>
                          <Input
                            type="textarea"
                            value={aditionalNote}
                            placeholder={i18n.t("WriteYourNoteHere")}
                            onChange={(e) => setAditionalNote(e.target.value)}
                            onBlur={(e) => onBlurAditionalNote(e.target.value)}
                          />
                        </>
                      )}
                    </Col>
                  )}
                  {showRequestData && (<hr/>)}
                  {(showRequestData && !showEmployees && typeService.value === BookingType.CLOSED) && (
                    <Col xxl={12} md={12} xs={12} style={{ opacity: 0, height: 0, overflow: 'hidden' }}>
                      <Link 
                        className="request-create-title"
                        onClick={() => dropDownHidde(!showScales, VisibilityTypes.SCALES)}
                      >
                        <h6 className="request-create-title">
                          { `${i18n.t("Scales")} ${arrScales[0]?.description ? `(${arrScales.length})` : '' } ` }
                          <i className={ `${showScales ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                        </h6>
                      </Link>
                      <p className="request-create-text" htmlFor="scalesInput">{i18n.t("AddedScalesEmployees")}</p>
                      {showScales && (
                        <Col xxl={12} md={12} xs={12}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              {(arrScales || []).map((formRow, key) => (
                                <tr key={key}>
                                  <td>
                                    <Row>
                                      <Col xxl={5} md={5} xs={12} className="scale-input">
                                        <div className="col-sm-auto mb-2">
                                          <Label className="visually" htmlFor="scaleAddressInput">
                                            {i18n.t("Scale") + " " + (key + 1)}
                                            {formRow.employeeId && (
                                              <span className="badge bg-info ms-2">
                                                {i18n.t("EmployeeScale")}
                                              </span>
                                            )}
                                          </Label>
                                          <PlacesServices
                                            selectedDestiny={selectedDestiny}
                                            setAddressesMarkers={setAddressesMarkers}
                                            selectedAddress={formRow}
                                            addressesMarkers={addressesMarkers}
                                            setSelectedAddress={(newAddress) => {
                                              if (!formRow.employeeId) {
                                                handleScaleAddressChange(newAddress, key);
                                              }
                                            }}
                                            typeAddress={TypeAddress.ARRAY_SCALES}
                                            setSelectedDestiny={setSelectedDestiny}
                                            disabled={!!formRow.employeeId}
                                            rowsData={arrScales}
                                            setRowsScale={setArrScales}
                                            rowsIndex={formRow}
                                            titleAdressDestiny={titleAdressDestiny}
                                            setNameTitleDestiny={setNameTitleDestiny}
                                            titleAdressOrigin={titleAdressOrigin}
                                            setNameTitleOrigin={setNameTitleOrigin}
                                            setOnFocusAddress={setOnFocusAddress}
                                            setNewCreateAddressEmployee={setNewCreateAddressEmployee}
                                            id={`arrayScales-${formRow.id}`}
                                          />
                                        </div>
                                      </Col>
                                      <Col xxl={2} md={2} xs={2}>
                                        <div className="d-grid mt-4">
                                          {arrScales[key].description && !formRow.employeeId && (
                                            <Link className="delete-scale-buttom" onClick={() => handleRemoveRowScale(formRow.id)}>
                                              <i className="fa fa-trash text-danger" />
                                            </Link>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <Link
                            className="add-scale-text"
                            onClick={() => {
                              handleAddRowScale();
                            }}
                          >
                            <i className="bx bx-plus add-scale-icon" />
                            {i18n.t("AddScale")}
                          </Link>
                        </Col>
                      )}
                    </Col>
                  )}
                  {!showEmployees && (
                    <>
                      {showNextBlock && <hr />}
                      {(isPartnerAllowed(company.value || infoUser?.partner_id) && showNextBlock && (
                        <>
                          <Col xxl={12} md={12} xs={12}>
                            <Link
                              className="request-create-title"
                              onClick={() => (originAddressService.description) && dropDownHidde(!showIdTag, VisibilityTypes.IDTAG)}
                            >
                              <h6 className="request-create-title">
                                {i18n.t("IdTag")}
                                <i className={`${showIdTag ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon`} />
                              </h6>
                            </Link>
                            <p className="request-create-text" htmlFor="companyInput">
                              {i18n.t("AddIdTag")}
                            </p>
                            {showIdTag && (
                              <Row>
                                <Col xxl={12} md={12} xs={12}>
                                  <Label>{i18n.t("IdTagLabel")}</Label>
                                  <Input
                                    type="textarea"
                                    value={idTag}
                                    placeholder={i18n.t("IdTagPlaceholder")}
                                    onChange={(e) => setIdTag(e.target.value)}
                                  />
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <hr />
                        </>
                      ))}
                    </>
                  )}
                  {(showRequestData &&
                    <Col xxl={12} xl={12} xs={12} className="pt-2 d-flex">
                      <button
                        onClick={() => {
                          if (isEditMode) {
                            onClickUpdateRequest();
                          } else {
                            onClickCreateRequest();
                          }
                          setContinueClicked(true);
                        }}
                        className="btn btn-request"
                        disabled={isDisabled}
                      >
                        {i18n.t(isEditMode ? "Update" : "Continue")}
                      </button>
                    </Col>
                  )}
                  <Col xxl={12} xl={12} xs={12}>
                    {!showEmployees && !showAssignedUnit && <hr />}
                    <Link
                      className="request-step-title"
                      onClick={() => {
                        setShowAssignedUnit(!showAssignedUnit);
                        setShowRequestData(false);
                      }}
                    >
                      <h6 className="request-step-title">
                      <span className="request-number-circle">2</span>
                      {i18n.t("AssignUnit")}
                      <i className={`${showAssignedUnit ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon`} />
                      </h6>
                    </Link>
                    {showAssignedUnit && (
                      <>
                        <Label>
                          {i18n.t("PlateNumber")}
                        </Label>
                        <p className="request-create-text" htmlFor="companyInput">
                          {i18n.t("EnterPlateNumber")}
                        </p>
                        <div className="search-container">
                          <Input
                            className="input-employee-data"
                            value={searchPlateQuery}
                            placeholder={i18n.t("SelectPlate")}
                            onChange={(e) => handlePlateSearch(e.target.value)}
                            onFocus={() => searchPlateQuery && setShowPlateDropdown(true)}
                            onBlur={() => setTimeout(() => setShowPlateDropdown(false), 200)}
                          />
                          {isLoadingPlates ? (
                            <div className="search-dropdown">
                              <div className="dropdown-item">{i18n.t("LoadingPlates")}</div>
                            </div>
                          ) : (
                            showPlateDropdown && plateResults.length > 0 && (
                              <div className="search-dropdown">
                                {plateResults.map((plateInfo, index) => (
                                  <div 
                                    key={index}
                                    className="dropdown-item"
                                    onClick={() => handlePlateSelect(plateInfo)}
                                  >
                                    <div>
                                      <strong>{plateInfo.plate}</strong>
                                      <div className="text-muted small">
                                        {plateInfo.full_name}
                                        {plateInfo.vehicle?.make_model && (
                                          <span> • {plateInfo.vehicle.make_model}</span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )
                          )}
                        </div>
                      </>
                    )}
                    {!showEmployees && <hr />}
                  </Col>
                </Col>
                {(
                  <Col xxl={6} md={6} xs={12}>
                    <MapServices
                      titleAdressArrScales={titleAdressArrScales}
                      titleAdressArrEmployees={titleAdressArrEmployees}
                      setNameTitleDestiny={setNameTitleDestiny}
                      titleAdressDestiny={titleAdressDestiny}
                      setNameTitleArrScales={setNameTitleArrScales}
                      setNameTitleEmployees={setNameTitleEmployees}
                      titleAdressOrigin={titleAdressOrigin}
                      setNameTitleOrigin={setNameTitleOrigin}
                      selectedDestiny={selectedDestiny}
                      selectedOrigin={selectedOrigin}
                      setShowUnits={setShowUnits}
                      setNewCreateAddressEmployee={setNewCreateAddressEmployee}
                      servicesView={true}
                      setShowAddresses={setShowAddresses}
                      showAddresses={showAddresses}
                      setAddressesMarkers={setAddressesMarkers}
                      addressesMarkers={addressesMarkers}
                      selectedAddress={destinyAddressService}
                      setFindEmployees={setFindEmployees}
                      findEmployees={findEmployees}
                      setShowEmployees={setShowEmployees}
                      typeService={typeService}
                      setArrScales={setArrScales}
                      arrScales={arrScales}
                      setSelectedAddress={setDestinyAddressService}
                      selectedAddressOrigin={originAddressService}
                      setSelectedAddressOrigin={setOriginAddressService}
                      selectedAddressDestiny={destinyAddressService}
                      setSelectedAddressDestiny={setDestinyAddressService}
                      typeAddress={onFocusAddress}
                      setOnFocusAddress={setOnFocusAddress}
                      setSelectedDestiny={setSelectedDestiny}
                      setSelectedOrigin={setSelectedOrigin}
                      disabled={false}
                    />
                  </Col>
                )}
                {!showEmployees && (
                  <>
                    <Col xxl={12} xl={12} xs={12} className="pt-2">
                      <div className="d-flex flex-column flex-md-row gap-2">
                        <button
                          onClick={async () => {
                            if (!selectedPlate) {
                              setErrorAlertMessage(i18n.t("PleaseSelectPlate"));
                              setErrorAlert(true);
                              return;
                            }
                            if (!serviceCode) {
                              console.warn("No service code available.");
                              setErrorAlertMessage(i18n.t("NoServiceCodeAvailable"));
                              setErrorAlert(true);
                              return;
                            }
                            const assignmentSuccess = await assignPlateToService(
                              { code: serviceCode },
                              selectedPlate
                            );
                            if (assignmentSuccess) {
                              setSearchPlateQuery("");
                              setSelectedPlate(null);
                              setShowRequestData(true);
                              setShowAssignedUnit(false);
                              window.location.reload();
                            }
                          }}
                          className="btn btn-request flex-grow-1 flex-md-grow-0"
                          disabled={isDisabled || !selectedPlate}
                        >
                          {i18n.t("Accept&RequestNewService")}
                        </button>
                        <button
                          onClick={async () => {
                            if (!selectedPlate) {
                              setErrorAlertMessage(i18n.t("PleaseSelectPlate"));
                              setErrorAlert(true);
                              return;
                            }
                            if (!serviceCode) {
                              console.warn("No service code available.");
                              setErrorAlertMessage(i18n.t("NoServiceCodeAvailable"));
                              setErrorAlert(true);
                              return;
                            }
                            const assignmentSuccess = await assignPlateToService(
                              { code: serviceCode },
                              selectedPlate
                            );
                            if (assignmentSuccess) {
                              history("/services/request");
                            }
                          }}
                          className="btn btn-accept-exit flex-grow-1 flex-md-grow-0"
                          disabled={isDisabled || !selectedPlate}
                        >
                          {i18n.t("Accept&Exit")}
                        </button>
                        <Link 
                          to={"/services/request"} 
                          className="btn btn-go-back flex-grow-1 flex-md-grow-0 mx-md-2"
                        >
                          {i18n.t("GoBack")}
                        </Link>
                      </div>
                    </Col>
                  </>
                )}
              </Row>
            </Card>
          </div>
        </div>
        <AlertError
          showAlertError={errorAlert}
          setShowAlertError={handleCloseErrorAlert}
          textHeader={errorAlertHeader}
          textBody={errorAlertMessage}
        />
        <AlertSuccess
          showAlertSuccess={showAlertSuccess}
          setShowAlertSuccess={setShowAlertSuccess}
          textHeader={alertHeader}
          textBody={alertBody}
        />
      </div>
    </Fragment>
  );
};

export default ExpressRequestService;
